import {
  ConsumerPrivacyAction,
  ConsumerPrivacyModalAction,
  ConsumerPrivacyURL,
} from './ConsumerPrivacyConstants';
import { ConsumerPrivacyObject, ConsumerPrivacyState } from './ConsumerPrivacyTypes';
import { ConsumerPrivacy } from '../../../types';

const initialState = {
  list: [],
  item: {},
  modal: {
    state: false,
    action: '',
  },
};

export default function(state = initialState, action: any) {
  switch (action.type) {
    case ConsumerPrivacyAction.FETCH_CONSUMERPRIVACY:
      return {
        ...state,
        list: action.payload.ConsumerPrivacyList,
      };

    case ConsumerPrivacyAction.SHOW_CONSUMERPRIVACY:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          state: action.payload.modal.state,
          action: action.payload.modal.action,
        },
      };

    case ConsumerPrivacyAction.HIDE_CONSUMERPRIVACY:
      return {
        ...state,
        modal: {
          ...state.modal,
          state: false,
        },
      };

    case ConsumerPrivacyAction.UPDATE_CONSUMERPRIVACY_ITEM:
      return {
        ...state,
        item: action.payload.item,
      };

    case ConsumerPrivacyAction.CLONE_CONSUMERPRIVACY:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          ...action.payload.modal,
        },
      };

    case ConsumerPrivacyAction.UPDATE_CONSUMERPRIVACY_LIST:
      return {
        ...state,
        list: action.payload.ConsumerPrivacyList,
      };

    case ConsumerPrivacyAction.SAVE_CONSUMERPRIVACY:
      return {
        ...state,
        item: action.payload.item,
        modal: {
          state: action.payload.modal.state,
        },
      };

    case ConsumerPrivacyAction.DELETE_CONSUMERPRIVACY:
      return {
        ...state,
      };

    default:
      return state;
  }
}
